import Button from '@ui-kit/components/button';
import { t, useBehaviorSubject } from '@base/utils/helpers';
import { GameState } from '../../model/interfaces';
import React from 'react';
import { ReactComponent as CheckIcon } from '@ui-kit/icons/check.svg';
import { ReactComponent as DiceIcon } from '@ui-kit/icons/dice.svg';
import { ReactComponent as UndoIcon } from '@ui-kit/icons/undo.svg';
import { container } from 'tsyringe';
import { GameButton } from '@base/features/game/model/interfaces';
import { IPreferencesService } from '@base/features/preferences/model/types';
import { Preferences } from '@backgammon/constants/defaultPreferences';
import BaseGameButtons, { GameButtons as Buttons } from '@base/features/game/components/gameButtons/baseGameButtons';

export default function GameButtons(props: { gameState: GameState }) {
  const preferencesService: IPreferencesService<Preferences> = container.resolve('preferencesService');
  const takeBackLockActive = useBehaviorSubject(props.gameState.onTakeBackLockChanged);
  const AUTO_CONFIRM_TIMEOUT = 25;

  const buttons: Buttons = {
    [GameButton.DONE]: (
      <Button
        onClick={() => props.gameState.diceClick()}
        icon={<CheckIcon />}
        color="green"
        timer={preferencesService.getPreferences('AUTO_CONFIRM') ? AUTO_CONFIRM_TIMEOUT : undefined}
      >
        {t('done')}
      </Button>
    ),
    [GameButton.ROLL]:
      !preferencesService.getPreferences('AUTO_ROLL') && !takeBackLockActive ? (
        <Button onClick={() => props.gameState.diceClick()} color="blue" icon={<DiceIcon />}>
          {t('roll')}
        </Button>
      ) : undefined,
    [GameButton.SHOW_DOUBLE_DIALOG]: (
      <Button onClick={() => props.gameState.showDoubleDialog()} color="blue">
        {t('Show')}
      </Button>
    ),
    [GameButton.UNDO]: (
      <Button onClick={() => props.gameState.undoClick()} color="red" icon={<UndoIcon />}>
        {t('undo')}
      </Button>
    ),
  };

  return (
    <div className="game-buttons">
      <BaseGameButtons gameState={props.gameState}>{buttons}</BaseGameButtons>
    </div>
  );
}
